import { render, staticRenderFns } from "./CateNav.vue?vue&type=template&id=771225eb&scoped=true&"
import script from "./CateNav.vue?vue&type=script&lang=js&"
export * from "./CateNav.vue?vue&type=script&lang=js&"
import style0 from "./CateNav.vue?vue&type=style&index=0&id=771225eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771225eb",
  null
  
)

component.options.__file = "CateNav.vue"
export default component.exports